module.exports = __webpack_public_path__ + "static/media/sicherung_fragezeichen.4d775686.jpg";